// eslint-disable-next-line no-unused-vars
import React, { useState, useRef, useEffect, useCallback, useMemo } from 'react'
import $ from 'jquery'; 
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
//import { Sortable } from '@shopify/draggable';
//import Draggable, {DraggableCore} from 'react-draggable'; // Both at the same time
import { ajaxPerso, fetchBrands, meta } from '../fnc'
import Select from 'react-select';
import {
	NavLink
} from 'react-router-dom';
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import ChangeImage from "./ctn/imageShopify/ChangeImage";
import AddBrandPageImage from "./ctn/imageShopify/AddBrandPageImage";
import AddImageToCdn from "./ctn/imageShopify/AddImageToCdn";
import SpecialBanner from "./ctn/Themes/SpecialBanner";
import store from 'store2';
const refConst = require("../constants.js").v

var initialState = {
	stores: [],
	_isMounted: false
}

const subCatPrefix = [
	"subCatIcon_",
	"flag_",
	"brandPage_"
]

export default (props) => {

	const stores = refConst.stores.filter(o => {
		if(o.id_marketplace == 14)	return o
		return false
	})
	let objPreSelected = store("storeSelectedShImg")
	const [shopSelected, setShopSelected] = useState(objPreSelected? objPreSelected : stores[0]);

	const [shopifyStores, setShopifyStores] = useState([]);
	const [prefixSelected, setPrefixSelected] = useState(null);
	const [imagesData, setImagesData] = useState({imgs: [], info: null});
	const [brands, setBrands] = useState([]);
	const [brandColors, setBrandColors] = useState({});
	const [metaId, setMetaId] = useState(null);

	useEffect(() => {
		initialState._isMounted = true;

		return () => initialState._isMounted = false
	}, [])

	useEffect(() => {
		if(refConst.stores.length > 0)
			setShopifyStores( refConst.stores.filter(o => {
				if(o.id_marketplace == 14)	return o
				return false
			}))
	}, [refConst.stores])

	useEffect(() => {
		if(!shopSelected || !shopSelected.id)	return;
		
		// Fetch brands
		props.loading(true);
		fetchBrands(shopSelected.id, { onlyActive: true }, null, (r) => {
			if(!initialState._isMounted)	return false
			console.info('Fetched brands:', r);
			if(r.success){
				setBrands(r.data || [])
			}
		});

		// Fetch existing metafield
		meta.fetch({
			shop: shopSelected.id,
			namespace: "theme",
			key: "brand_colors"
		}, (r) => {
			if(!initialState._isMounted)	return false
			console.info('Fetched brand colors metafield:', r);
			if(r.success && r.res && r.res.length > 0){
				const metafield = r.res[0];
				setMetaId(metafield.id);
				try {
					const colors = JSON.parse(metafield.value);
					// Convert old format (string values) to new format (object with mainColor)
					const convertedColors = {};
					Object.keys(colors || {}).forEach(brandName => {
						if(typeof colors[brandName] === 'string') {
							// Old format: "wera": "#000000"
							convertedColors[brandName] = { mainColor: colors[brandName] };
						} else if(colors[brandName] && typeof colors[brandName] === 'object') {
							// New format: "wera": {mainColor: "#000000"}
							convertedColors[brandName] = colors[brandName];
						}
					});
					setBrandColors(convertedColors);
				} catch(e) {
					console.error('Error parsing metafield value:', e);
					setBrandColors({});
				}
			} else {
				setMetaId(null);
				setBrandColors({});
			}
			props.loading(false);
		});
	}, [shopSelected])

	useEffect(() => {
		if(!prefixSelected || !shopSelected.id)	return;
		props.loading(true);
		fetchImages({
			"shop": shopSelected.id,
			"filter_name": prefixSelected.value,
			"includeDetails": false
		}, (r) => {
			console.info('Result fetchImages', r);
			props.loading(false);
			if(r.errors)	props.info({"error": r.errors})
			setImagesData(r.success? {
				imgs: r.urlList,
				info: r.pageInfo
			} : {imgs: [], info: null})
		})
	}, [prefixSelected])

	const fetchImages = (args, callback) => {
		if(!initialState._isMounted)	return false
		ajaxPerso( Object.assign({
			"api": "shopify",
			"trigger": "get_admin_files",
			"autoLoad": false,
			"qty": 20,
		}, args), callback);
	}

	const loadMoreImages = () => {
		props.loading(true);
		fetchImages({
			"shop": shopSelected.id,
			"filter_name": prefixSelected.value,
			"includeDetails": false,
			"after": imagesData.info.endCursor
		}, (r) => {
			console.info('Result loadMoreImages', r);
			props.loading(false);
			if(r.errors)	props.info({"error": r.errors})
			else if(r.success){
				imagesData.imgs = imagesData.imgs.concat(r.urlList)
				imagesData.info = r.pageInfo
				setImagesData(Object.assign({}, imagesData))
			}
		})
	}

	const addBrandColor = (brandName) => {
		if(!brandName || brandName in brandColors)	return;
		setBrandColors(prev => ({
			...prev,
			[brandName]: {
				mainColor: "#000000"
			}
		}));
	}

	const removeBrandColor = (brandName) => {
		setBrandColors(prev => {
			const newColors = {...prev};
			delete newColors[brandName];
			return newColors;
		});
	}

	const updateBrandColor = (brandName, color) => {
		setBrandColors(prev => ({
			...prev,
			[brandName]: {
				...prev[brandName],
				mainColor: color
			}
		}));
	}

	const getAvailableBrands = () => {
		return brands.filter(brand => {
			const brandName = brand.name || brand.brand_name || brand;
			return !(brandName in brandColors);
		});
	}

	const saveBrandColors = () => {
		if(!shopSelected || !shopSelected.id)	return;
		
		props.loading(true);
		meta.create({
			shop: shopSelected.id,
			namespace: "theme",
			key: "brand_colors",
			value: brandColors
		}, (r) => {
			if(!initialState._isMounted)	return false
			console.info('Saved brand colors metafield:', r);
			props.loading(false);
			if(r.success){
				if(r.json && r.json.id)	setMetaId(r.json.id);
				props.info({success: "Brand colors saved successfully!"});
			} else {
				props.info({error: r.error || "Failed to save brand colors"});
			}
		});
	}

	const sectionColorPickerPerBrand = () => {
		const availableBrands = getAvailableBrands();
		const brandColorEntries = Object.entries(brandColors);
		
		return <div className="border shadow rounded radius p-3 w-100 bg-light">
			<h5 className="mb-3">Brand Color Customization</h5>
			<p className="text-muted mb-3">Customize colors for each brand in your Shopify theme</p>
			
			{/* Existing brand colors */}
			{brandColorEntries.length > 0 && (
				<div className="mb-4">
					<h6 className="mb-3">Configured Brands</h6>
					{brandColorEntries.map(([brandName, brandObj]) => {
						const mainColor = brandObj?.mainColor || "#000000";
						return (
							<div key={brandName} className="d-flex align-items-center mb-3 p-3 border rounded bg-white">
								<div className="flex-grow-1">
									<label className="font-weight-bold mb-1">{brandName}</label>
									<div className="d-flex align-items-center">
										<input
											type="color"
											className="form-control mr-2"
											style={{width: '60px', height: '40px', padding: '2px', cursor: 'pointer'}}
											value={mainColor}
											onChange={(e) => updateBrandColor(brandName, e.target.value)}
										/>
										<span className="mr-3">{mainColor}</span>
									</div>
								</div>
								<button
									className="btn btn-danger btn-sm"
									onClick={() => removeBrandColor(brandName)}
									title="Remove brand color"
								>
									<FontAwesomeIcon icon={faTrash} />
								</button>
							</div>
						);
					})}
				</div>
			)}

			{/* Add new brand color */}
			{availableBrands.length > 0 && (
				<div className="mb-4">
					<h6 className="mb-3">Add Brand Color</h6>
					<Select
						placeholder="Select a brand to add..."
						options={availableBrands.map(brand => {
							const brandName = brand.name || brand.brand_name || brand;
							return {
								value: brandName,
								label: brandName
							};
						})}
						onChange={(selected) => {
							if(selected && selected.value){
								addBrandColor(selected.value);
							}
						}}
						isSearchable={true}
						styles={{
							control: (base) => ({
								...base,
								minHeight: 38
							})
						}}
					/>
				</div>
			)}

			{/* Submit button */}
			<div className="d-flex justify-content-end">
				<button
					className="btn btn-primary"
					onClick={saveBrandColors}
					disabled={Object.keys(brandColors).length === 0}
				>
					Save Brand Colors
				</button>
			</div>

			{/* JSON preview (optional, for debugging) */}
			{/* We show the preview only for refConst.UID_system */}
			{Object.keys(brandColors).length > 0 && refConst.UID_system === props.getUser().uid && (
				<div className="mt-4">
					<details>
						<summary className="text-muted cursor-pointer" style={{cursor: 'pointer'}}>Preview JSON</summary>
						<pre className="bg-dark text-light p-3 rounded mt-2" style={{maxHeight: '200px', overflow: 'auto'}}>
							{JSON.stringify(brandColors, null, 2)}
						</pre>
					</details>
				</div>
			)}
		</div>
	}

	
	if(!props.securityClearance(props))	return "";
	
	return (
		<div className="main ctnPage container d-flex flex-row flex-wrap">
			<div className="input-group mb-4">
				<div className="input-group-prepend">
					<span className="input-group-text" id="basic-addon1">Website</span>
				</div>
				<select className="custom-select font-weight-bold" value={ shopSelected? JSON.stringify(shopSelected) : false } onChange={(e) => {
					store("storeSelectedShImg", JSON.parse(e.target.value))
					setShopSelected(JSON.parse(e.target.value))
				}}>
					{
						stores.length > 0? stores.map(o => {
							return <option key={o.name} value={JSON.stringify(o)}>{o.name}</option>
						}) : []
					}
				</select>
			</div>
			{ sectionColorPickerPerBrand() }
			<SpecialBanner shopSelected={shopSelected} props={props} />
		</div>
	);
};